import react, {Component} from "react";
import { Navigate } from "react-router-dom";

import axiosBaseURL from "../httpCommon";

class Login extends Component {
    constructor(props){
        super(props);
        const queryParams = new URLSearchParams(window.location.search);
        this.state={
            target_url: queryParams.get('target_url') === null ? "/" : queryParams.get('target_url'),
            mobile: "",
            password: "",
            msg: "",
            errMsg: [],
            redirect: false,
            loading: false
        }
    }

    changeHandler=(event)=>{
        this.setState({
            [event.target.name]: event.target.value
        })
    }

    submitHandler=()=>{
        this.setState({
            loading: true
        })
        axiosBaseURL.post('api/v1/login', {
            mobile: this.state.mobile,
            password: this.state.password
        })
            .then(response => {
                if(response.data.status === 200){
                    window.localStorage.setItem("isLoggedIn", true);
                    window.localStorage.setItem("userData", JSON.stringify(response.data.data));
                    this.setState({
                        msg: response.data.message,
                        redirect: true,
                        errMsg: ""
                    });
                    window.location.href = this.state.target_url
                    //this.refreshPage();
                }
                if (response.data.status === "failed"){
                    this.setState({
                        errMsg: response.data.validation_error,
                        loading: false,
                        msg: ""
                    });
                }
                else if(response.data.status === "404"){
                    this.setState({
                        errMsg: "",
                        loading: false,
                        msg: response.data.message
                    });
                }
            })
            .catch(error => {
                this.setState({
                    loading: false
                })
                console.log(error);
            })
    }

    refreshPage=()=> {
        window.location.reload(false);
    }

    render() {
        const login = window.localStorage.getItem("isLoggedIn");
        if (login || this.state.redirect) {
            return <Navigate to="/" />;
        }

        const {loading} = this.state

        return(
            <>
                <img src="/logo192.png" class="img-fluid design-top" alt="" width="115" height="auto" />

                <section class="form-section px-15 top-space section-b-space">
                    <h1>Hey, <br/>Login Now</h1>
                    <form>
                        <div class="form-floating mb-4">
                            <input name="mobile" id="mobile" className="form-control" type="text" placeholder="10 Digit Mobile" tabIndex="1" value={this.state.mobile} onChange={this.changeHandler} maxLength={10}/>
                            <label htmlFor="mobile">10 Digit Mobile</label>
                            <span className="text-danger">{this.state.errMsg.mobile}</span>
                        </div>
                        <div class="form-floating mb-2">
                            <input className="form-control" id="password" name="password" type="password" placeholder="Password" tabIndex="2" minLength="6" maxLength="15" value={this.state.password} onChange={this.changeHandler}/>
                            <label htmlFor="password">Password</label>
                            <span className="text-danger">{this.state.errMsg.password}</span>
                        </div>
                        <p className="text-danger">{this.state.msg}</p>
                        <div className="mt-4">
                            <button type="submit" className="btn btn-solid w-100" onClick={this.submitHandler} disabled={loading}>
                                {loading && (
                                    <img src={"/loader.gif"} width="20" height="20" className="mr-3"/>
                                )}
                                {loading && <>Checking Details</>}
                                {!loading && <>Login</>}
                            </button>
                        </div>
                    </form>
                </section>

                <section class="panel-space"></section>
            </>
        );
    }
}

export default Login;